/* Boulanger-style left drawer, opened from the theme "TOUS LES PRODUITS" button.
 * Hides the native #nav mega-menu and lower #nav-bar. Works on mobile + desktop.
 * Data: assets/nav-tree.json
 */
(function () {
  'use strict';
  if (window.__blDrawerInit) return;
  window.__blDrawerInit = true;

  document.querySelectorAll('.bl-drawer, .bl-drawer-overlay, #bl-drawer-btn').forEach(function (el) {
    try { el.remove(); } catch (e) {}
  });

  var state = {
    tree: null,
    loading: false,
    stack: [],
    lastDir: 'forward'
  };

  function navTreeUrl() {
    var tagged = document.querySelector('[data-nav-tree-url]');
    if (tagged && tagged.getAttribute('data-nav-tree-url')) {
      return tagged.getAttribute('data-nav-tree-url');
    }
    var probe = document.querySelector('link[href*="/cdn/shop/t/"], script[src*="/cdn/shop/t/"]');
    var ref = probe ? (probe.href || probe.src || '') : '';
    var m = ref.match(/^(.*\/cdn\/shop\/t\/\d+\/assets\/)/);
    if (m) return m[1] + 'nav-tree.json';
    return '/cdn/shop/t/3/assets/nav-tree.json';
  }

  function loadTree(cb) {
    if (state.tree) { cb(); return; }
    if (state.loading) return;
    state.loading = true;
    fetch(navTreeUrl(), { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (json) {
        state.tree = json;
        state.loading = false;
        cb();
      })
      .catch(function () {
        state.loading = false;
        var body = document.querySelector('.bl-drawer__body');
        if (body) body.innerHTML = '<p class="bl-drawer__error">Impossible de charger le menu.</p>';
      });
  }

  function nodeOf(handle) {
    var n = state.tree && state.tree[handle];
    return (n && typeof n === 'object' && !Array.isArray(n)) ? n : null;
  }

  function hasChildren(handle) {
    var n = nodeOf(handle);
    return !!(n && n.children && n.children.length);
  }

  function roots() {
    var r = state.tree && state.tree.__roots__;
    return Array.isArray(r) ? r : [];
  }

  var CHEVRON_SVG =
    '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">' +
    '<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M9 6l6 6-6 6"/></svg>';
  var BACK_SVG =
    '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
    '<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M15 18l-6-6 6-6"/></svg>';
  var CLOSE_SVG =
    '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
    '<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M5 5l14 14M19 5L5 19"/></svg>';

  var overlay, drawer;

  function buildDrawer() {
    if (drawer) return;
    overlay = document.createElement('div');
    overlay.className = 'bl-drawer-overlay';
    overlay.addEventListener('click', closeDrawer);

    drawer = document.createElement('aside');
    drawer.className = 'bl-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'TOUS LES PRODUITS');
    drawer.innerHTML =
      '<div class="bl-drawer__head">' +
      '  <button type="button" class="bl-drawer__back" aria-label="Retour">' + BACK_SVG + '</button>' +
      '  <span class="bl-drawer__title"></span>' +
      '  <button type="button" class="bl-drawer__close" aria-label="Fermer">' + CLOSE_SVG + '</button>' +
      '</div>' +
      '<div class="bl-drawer__body"></div>';

    var btnStyle =
      'display:inline-flex!important;align-items:center!important;justify-content:center!important;' +
      'width:36px!important;height:36px!important;min-width:36px!important;min-height:36px!important;' +
      'max-width:36px!important;max-height:36px!important;margin:0!important;padding:0!important;' +
      'border:0!important;border-radius:50%!important;background:rgba(255,255,255,0.14)!important;' +
      'box-shadow:none!important;color:#fff!important;font-size:0!important;line-height:1!important;' +
      'flex:0 0 36px!important;cursor:pointer!important;transform:none!important;';
    drawer.querySelectorAll('.bl-drawer__back, .bl-drawer__close').forEach(function (b) {
      b.setAttribute('style', btnStyle);
    });
    var titleEl = drawer.querySelector('.bl-drawer__title');
    if (titleEl) {
      titleEl.setAttribute(
        'style',
        'flex:1 1 auto;min-width:0;margin:0;padding:0;color:#fff;font-size:16px;font-weight:700;' +
          'line-height:1.3;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'
      );
    }
    var headEl = drawer.querySelector('.bl-drawer__head');
    if (headEl) {
      headEl.setAttribute(
        'style',
        'display:flex;align-items:center;gap:10px;padding:10px 14px;background:#1b1d29;color:#fff;' +
          'min-height:56px;box-sizing:border-box;'
      );
    }

    drawer.querySelector('.bl-drawer__back').addEventListener('click', function () {
      if (state.stack.length) {
        state.stack.pop();
        state.lastDir = 'back';
        render();
      }
    });
    drawer.querySelector('.bl-drawer__close').addEventListener('click', closeDrawer);

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  function openDrawer(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }
    // Close native Xtra mega-menu if it started opening
    document.documentElement.classList.remove('t1mn', 'm1n', 'nav-hover');
    var nativeNav = document.getElementById('nav');
    if (nativeNav) {
      nativeNav.classList.add('bl-native-nav-disabled');
      nativeNav.setAttribute('hidden', 'hidden');
    }

    buildDrawer();
    document.documentElement.classList.add('bl-drawer-open');
    overlay.classList.add('is-visible');
    drawer.classList.add('is-open');
    render();
    loadTree(render);
  }

  function closeDrawer() {
    if (!drawer) return;
    document.documentElement.classList.remove('bl-drawer-open');
    overlay.classList.remove('is-visible');
    drawer.classList.remove('is-open');
    state.stack = [];
    state.lastDir = 'forward';
  }

  function skeletonHTML() {
    var rows = '';
    for (var i = 0; i < 9; i++) {
      rows += '<li class="bl-drawer__skel"><span class="bl-drawer__skel-bar"></span></li>';
    }
    return '<ul class="bl-drawer__list bl-drawer__list--skeleton">' + rows + '</ul>';
  }

  function itemHTML(child, withImage) {
    var drill = hasChildren(child.handle);
    var img = '';
    if (withImage && child.image) {
      img = '<img class="bl-drawer__img" src="' + child.image + '" alt="" loading="lazy" width="40" height="40">';
    }
    var chev = drill ? '<span class="bl-drawer__chev">' + CHEVRON_SVG + '</span>' : '';
    return (
      '<li>' +
      '<a class="bl-drawer__item' + (drill ? ' has-children' : '') + '" href="' + child.url + '"' +
      ' data-handle="' + child.handle + '"' + (drill ? ' data-drill="1"' : '') + '>' +
      img + '<span class="bl-drawer__label">' + child.title + '</span>' + chev +
      '</a></li>'
    );
  }

  function render() {
    if (!drawer) return;
    var titleEl = drawer.querySelector('.bl-drawer__title');
    var backBtn = drawer.querySelector('.bl-drawer__back');
    var body = drawer.querySelector('.bl-drawer__body');
    if (!state.tree) {
      titleEl.textContent = 'TOUS LES PRODUITS';
      backBtn.classList.add('is-hidden');
      body.innerHTML = skeletonHTML();
      return;
    }

    var html;
    if (!state.stack.length) {
      titleEl.textContent = 'TOUS LES PRODUITS';
      backBtn.classList.add('is-hidden');
html = '<ul class="bl-drawer__list">' +
        roots().map(function (r) { return itemHTML(r, true); }).join('') +
        '</ul>';
    } else {
      var handle = state.stack[state.stack.length - 1];
      var node = nodeOf(handle);
      if (!node) { state.stack = []; render(); return; }
      titleEl.textContent = node.title;
      backBtn.classList.remove('is-hidden');
html = '<ul class="bl-drawer__list">' +
        '<li><a class="bl-drawer__item bl-drawer__item--all" href="' + node.url + '">' +
        '<span class="bl-drawer__label">Voir tout &mdash; ' + node.title + '</span></a></li>' +
        (node.children || []).map(function (c) { return itemHTML(c, false); }).join('') +
        '</ul>';
    }

    body.innerHTML = html;
    var list = body.querySelector('.bl-drawer__list');
    if (list) {
      list.classList.add(state.lastDir === 'back' ? 'slide-back' : 'slide-forward');
    }
    state.lastDir = 'forward';

    body.querySelectorAll('a[data-drill]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        state.stack.push(a.getAttribute('data-handle'));
        state.lastDir = 'forward';
        render();
      });
    });
  }

  function isCatalogueTrigger(el) {
    if (!el || el.closest('.bl-drawer')) return false;
    var a = el.closest('a, button');
    if (!a) return false;
    if (a.classList.contains('bl-camara-burger')) return true;
    if (a.classList.contains('bl-catalogue-trigger')) return true;
    if (a.closest('.bl-camara-burger, .bl-catalogue-trigger')) return true;
    if (a.getAttribute('aria-controls') === 'nav') return true;
    if (a.classList.contains('toggle-wide')) return true;
    var text = (a.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (text.indexOf('voir le catalogue') !== -1) return true;
    if (a.matches('#header-inner > .link-btn > a:first-child')) return true;
    return false;
  }

  function bindTriggers() {
    // Capture-phase so we beat the theme's own nav handlers
    document.addEventListener(
      'click',
      function (e) {
        if (!isCatalogueTrigger(e.target)) return;
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        openDrawer(e);
      },
      true
    );

    // Also mark triggers for accessibility / styling
    document.querySelectorAll(
      'a[aria-controls="nav"], #header-inner > .link-btn > a:first-child, a.toggle-wide, .bl-camara-burger, .bl-catalogue-trigger'
    ).forEach(function (a) {
      a.classList.add('bl-catalogue-trigger');
      a.setAttribute('aria-haspopup', 'dialog');
      a.setAttribute('role', 'button');
    });
  }

  function boot() {
    bindTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
